import script from "./AuthorizationWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuthorizationWidget.vue?vue&type=script&setup=true&lang=ts"

import "./AuthorizationWidget.vue?vue&type=style&index=0&id=10330b86&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10330b86"]])

export default __exports__